import { render, staticRenderFns } from "./ConsentimientosListado.vue?vue&type=template&id=40f0a064"
import script from "./ConsentimientosListado.vue?vue&type=script&lang=js"
export * from "./ConsentimientosListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports